import { Trans } from '@lingui/react/macro';
import { Card, CardContent, cn } from '@pantry/ui';

/**
 * Stat card component
 */
export function StatCard({
  title,
  value,
  subtitle,
  icon: Icon,
  isLoading,
  error,
  variant = 'default',
  delay = 0,
  dataTour,
}: {
  title: string;
  value: number;
  subtitle: string;
  icon: React.ComponentType<{ className?: string }>;
  isLoading: boolean;
  error: Error | null;
  variant?: 'default' | 'warning' | 'success';
  delay?: number;
  dataTour?: string;
}) {
  return (
    <Card
      className="animate-in overflow-hidden"
      style={{ animationDelay: `${delay}ms` }}
      data-tour={dataTour}
    >
      <CardContent className="p-5">
        <div className="flex items-start justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            {isLoading ? (
              <div className="h-9 w-16 animate-pulse rounded bg-muted mt-1" />
            ) : error ? (
              <p className="text-2xl font-bold text-destructive">
                <Trans>Error</Trans>
              </p>
            ) : (
              <p
                className={cn(
                  'text-3xl font-bold mt-1',
                  variant === 'warning' && value > 0 && 'text-expiring-soon',
                  variant === 'success' && 'text-fresh'
                )}
              >
                {value}
              </p>
            )}
            <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
          </div>
          <div
            className={cn(
              'flex h-10 w-10 items-center justify-center rounded-lg',
              variant === 'warning' && value > 0
                ? 'bg-expiring-soon/10'
                : variant === 'success'
                  ? 'bg-fresh/10'
                  : 'bg-muted'
            )}
          >
            <Icon
              className={cn(
                'h-5 w-5',
                variant === 'warning' && value > 0
                  ? 'text-expiring-soon'
                  : variant === 'success'
                    ? 'text-fresh'
                    : 'text-muted-foreground'
              )}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
